import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { useLoadPageState } from "../Hooks/useLoadPageState";
import loader from "../Assets/images/ezgif.com-animated-gif-maker.gif";

const LoadingWrapper = ({ children, className, id }) => {
  const [loading, setLoading] = useState(false);
  const loadingState = useLoadPageState();

  useEffect(() => {
    let handleTimeout;
    if (loadingState) {
      setLoading(true);
    } else {
      handleTimeout = setTimeout(() => {
        setLoading(loadingState);
      }, 100);
    }
    return () => {
      clearInterval(handleTimeout);
    };
  }, [loadingState]);

  return (
    <div id={id} className={clsx("loading-page", { loading }, className)}>
      <div className="loading-overlay">
        <div className="loading-spinner">
          <img src={loader} alt="loader" width="200px" />
        </div>
      </div>
      {children}
    </div>
  );
};

export default LoadingWrapper;
